import { useMemo } from 'react';
import { AllInteractionsResponse } from '../../store/backendApi';

interface UseInteractionStatsReturn {
  totalComments: number;
  totalLikes: number;
  totalViews: number;
}

/**
 * Hook to calculate interaction statistics totals.
 * Platform-agnostic: Pure calculation logic.
 *
 * @param interactions - The interactions data from API
 * @returns Calculated totals for comments, likes, and views
 */
export const useInteractionStats = (
  interactions?: AllInteractionsResponse,
): UseInteractionStatsReturn => {
  const stats = useMemo(() => {
    if (!interactions) {
      return {
        totalComments: 0,
        totalLikes: 0,
        totalViews: 0,
      };
    }

    return interactions.trips.reduce<UseInteractionStatsReturn>(
      (totals, trip) => {
        // Add trip views
        totals.totalViews += trip.views;

        // Loop through stories within the trip
        for (const story of trip.interactions.stories) {
          totals.totalLikes += story.likes.length;
          totals.totalComments += story.comments.length;
        }

        return totals;
      },
      {
        totalComments: 0,
        totalLikes: 0,
        totalViews: 0,
      },
    );
  }, [interactions]);

  return stats;
};
